/* ELEMENTO — THE DRAWING
   A house device: every piece is rendered as a to-scale atelier elevation,
   drawn from the dimensions the store already holds in custom.specifications,
   always accompanied by a bank card at the same scale so the size is legible
   without a tape measure. One engine, a different elevation per category. */
(function () {
  'use strict';

  var CARD_W = 8.56, CARD_H = 5.398;           /* ISO/IEC 7810 ID-1, in cm */
  var INK = '#1c1c1c', LINE = '#cfcdc9', ACC = '#4a2727', MUTE = '#8a8783';

  /* ---------------- parsing ---------------- */

  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* "15.5 × 10.5 × 8 H cm" / "42.5 × 44 H × 34.5 cm" / "13.9 × 27.4 × 37.2 cm" */
  function triples(s) {
    var re = /(\d+(?:\.\d+)?)\s*(H)?\s*[×x]\s*(\d+(?:\.\d+)?)\s*(H)?\s*[×x]\s*(\d+(?:\.\d+)?)\s*(H)?\s*cm/gi;
    var out = [], m;
    while ((m = re.exec(s))) {
      var v = [parseFloat(m[1]), parseFloat(m[3]), parseFloat(m[5])];
      var h = m[2] ? 0 : (m[4] ? 1 : (m[6] ? 2 : -1));
      var height, foot;
      if (h >= 0) { height = v[h]; foot = v.filter(function (_, i) { return i !== h; }); }
      else { height = v[2]; foot = [v[0], v[1]]; }
      var raw = foot.slice();
      foot = foot.slice().sort(function (a, b) { return b - a; });
      out.push({ long: foot[0], short: foot[1], a: raw[0], b: raw[1],
                 height: height, at: m.index, raw: m[0] });
    }
    return out;
  }

  function parse(spec, title) {
    var t = triples(spec);
    var o = { dims: t[0] || null, all: t };

    var oi = /outside\s+(.*?cm)/i.exec(spec);
    var ii = /inside\s+(.*?cm)/i.exec(spec);
    if (oi && ii) {
      var a = triples(oi[1])[0], b = triples(ii[1])[0];
      if (a && b) { o.outside = a; o.inside = b; o.dims = a; }
    }

    var holds = /holds?\s+(?:up\s+to\s+)?(\d+)/i.exec(spec);
    if (holds) o.holds = parseInt(holds[1], 10);

    var v = /(\d{3})\s*(?:–|—|-|to)\s*(\d{3})\s*V/i.exec(spec) || /\b(\d{3})\s*V\b/i.exec(spec);
    if (v) o.volts = v[2] ? (v[1] + '–' + v[2] + 'V') : (v[1] + 'V');

    var caps = { 'ONE': 1, '1': 1, 'TWO': 2, '2': 2, 'THREE': 3, '3': 3, 'EIGHT': 8, '8': 8 };
    var cm = /(\d+)\s*WATCH/i.exec(title || '');
    if (cm) o.watches = parseInt(cm[1], 10);
    if (!o.watches) {
      var sm = /(one|two|three|eight)\s+slots?/i.exec(spec);
      if (sm) o.watches = caps[sm[1].toUpperCase()];
    }

    var inc = /((?:supplied with|includes|comes with)[^.]*\.)/i.exec(spec);
    if (inc) o.included = inc[1].trim();

    if (/dimensions?\s+(?:are\s+)?(?:available\s+)?on\s+request/i.test(spec)) o.onRequest = true;
    return o;
  }

  /* ---------------- svg helpers ---------------- */

  var NS = 'http://www.w3.org/2000/svg';
  function el(n, a) {
    var e = document.createElementNS(NS, n);
    for (var k in a) if (a[k] != null) e.setAttribute(k, a[k]);
    return e;
  }
  function hair(x1, y1, x2, y2, colour, dash) {
    return el('line', { x1: x1, y1: y1, x2: x2, y2: y2, stroke: colour || LINE,
      'stroke-width': 1, 'stroke-dasharray': dash || null, 'vector-effect': 'non-scaling-stroke' });
  }
  function label(x, y, s, opt) {
    opt = opt || {};
    var t = el('text', { x: x, y: y, fill: opt.fill || MUTE, 'font-size': opt.size || 10,
      'letter-spacing': opt.ls || '.14em', 'text-anchor': opt.anchor || 'middle',
      'font-family': 'inherit' });
    t.textContent = s;
    return t;
  }
  /* dimension line with tick ends */
  function dim(x1, y1, x2, y2, txt, side) {
    var g = el('g', { class: 'eld__dim' });
    g.appendChild(hair(x1, y1, x2, y2, LINE));
    var vertical = Math.abs(x2 - x1) < Math.abs(y2 - y1);
    var t = 4;
    if (vertical) {
      g.appendChild(hair(x1 - t, y1, x1 + t, y1, LINE));
      g.appendChild(hair(x2 - t, y2, x2 + t, y2, LINE));
      var ty = (y1 + y2) / 2;
      var lt = label(0, 0, txt, { anchor: 'middle', size: 10 });
      lt.setAttribute('transform', 'translate(' + (x1 + (side === 'left' ? -10 : 10)) + ',' + ty + ') rotate(-90)');
      g.appendChild(lt);
    } else {
      g.appendChild(hair(x1, y1 - t, x1, y1 + t, LINE));
      g.appendChild(hair(x2, y2 - t, x2, y2 + t, LINE));
      g.appendChild(label((x1 + x2) / 2, y1 + (side === 'above' ? -8 : 16), txt));
    }
    return g;
  }
  function num(v) { return (Math.round(v * 10) / 10) + ' cm'; }

  /* ---------------- elevations ---------------- */

  function card(g, x, y, k) {
    var w = CARD_W * k, h = CARD_H * k;
    g.appendChild(el('rect', { x: x, y: y - h, width: w, height: h, rx: 3,
      fill: 'none', stroke: LINE, 'stroke-width': 1, 'stroke-dasharray': '3 3' }));
    g.appendChild(el('rect', { x: x + w * 0.08, y: y - h * 0.62, width: w * 0.22, height: h * 0.26,
      rx: 1.5, fill: 'none', stroke: LINE, 'stroke-width': 1, 'stroke-dasharray': '2 2' }));
    var t = label(x + w / 2, y + 14, 'BANK CARD, TO SCALE', { size: 8, ls: '.2em' });
    g.appendChild(t);
  }

  /* On a phone the wide sheet shrinks its annotations into illegibility.
     The narrow sheet stacks elevation over plan on a smaller canvas, so the
     same 9px annotations land roughly 1.6x larger once fitted. */
  function buildNarrow(box, data, cat, meta) {
    var W = 640, H = 700;
    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, class: 'eld__svg eld__svg--narrow',
      preserveAspectRatio: 'xMidYMid meet' });
    var g = el('g', {}); svg.appendChild(g);

    var d = data.dims;
    if (!d) return null;
    if (cat === 'watch-case' && d.a != null) d = { long: d.a, short: d.b, height: d.height };

    var GROUND = 230, planTop = 302;
    var k = Math.min((W * 0.62) / d.long, 190 / d.height, 190 / d.short);
    if (!isFinite(k) || k <= 0) k = 10;

    var pw = d.long * k, ph = d.height * k, pd = d.short * k;
    var cx = W * 0.50, x0 = cx - pw / 2, y0 = GROUND - ph;
    var radius = cat === 'watch-case' ? Math.min(ph / 2, pw / 2)
               : cat === 'tray' ? 5 : cat === 'card-sleeve' ? 4 : 3;

    g.appendChild(hair(W * 0.08, GROUND, W * 0.92, GROUND, LINE));

    var front = el('g', { class: 'eld__body' });
    front.appendChild(el('rect', { x: x0, y: y0, width: pw, height: ph, rx: radius,
      fill: 'none', stroke: INK, 'stroke-width': 1.5, 'vector-effect': 'non-scaling-stroke' }));
    if (cat === 'watch-case') {
      front.appendChild(hair(x0 + radius * 0.5, y0 + ph * 0.30, x0 + pw - radius * 0.5, y0 + ph * 0.30, LINE, '5 4'));
    }
    if (cat === 'chest' || cat === 'machine' || cat === 'watch-box') {
      front.appendChild(hair(x0, y0 + ph * 0.26, x0 + pw, y0 + ph * 0.26, LINE, '5 4'));
    }
    if (cat === 'tray' && data.inside) {
      var ih = data.inside.height * k, iw = data.inside.long * k;
      front.appendChild(el('rect', { x: cx - iw / 2, y: GROUND - ih, width: iw, height: ih, rx: 3,
        fill: 'none', stroke: ACC, 'stroke-width': 1, 'stroke-dasharray': '4 3' }));
    }
    g.appendChild(front);

    var plan = el('g', { class: 'eld__plan' });
    plan.appendChild(el('rect', { x: x0, y: planTop, width: pw, height: pd,
      rx: cat === 'watch-case' ? 6 : radius, fill: 'none', stroke: MUTE, 'stroke-width': 1.2 }));
    if (cat === 'watch-case') {
      var m = data.watches || 2;
      for (var j = 1; j < m; j++) plan.appendChild(hair(x0 + (pw / m) * j, planTop, x0 + (pw / m) * j, planTop + pd, LINE, '3 4'));
      for (var c = 0; c < m; c++) {
        plan.appendChild(el('rect', { x: x0 + (pw / m) * c + (pw / m) * 0.14, y: planTop + pd * 0.22,
          width: (pw / m) * 0.72, height: pd * 0.56, rx: (pw / m) * 0.16, fill: 'none', stroke: LINE, 'stroke-width': 1 }));
      }
    }
    if (cat === 'tray' && data.inside) {
      plan.appendChild(el('rect', { x: cx - data.inside.long * k / 2, y: planTop + (pd - data.inside.short * k) / 2,
        width: data.inside.long * k, height: data.inside.short * k, rx: 3,
        fill: 'none', stroke: ACC, 'stroke-width': 1, 'stroke-dasharray': '4 3' }));
    }
    if (cat === 'capsule-box' && data.holds) {
      var cols = Math.max(1, Math.round(Math.sqrt(data.holds * (pw / Math.max(pd, 1)))));
      var rows = Math.ceil(data.holds / cols);
      var rr = Math.min(pw / cols, pd / rows) * 0.32;
      for (var q = 0; q < data.holds; q++) {
        plan.appendChild(el('circle', { cx: x0 + pw * ((q % cols) + 0.5) / cols,
          cy: planTop + pd * (Math.floor(q / cols) + 0.5) / rows, r: rr,
          fill: 'none', stroke: ACC, 'stroke-width': 1 }));
      }
    }
    g.appendChild(plan);

    g.appendChild(dim(x0, GROUND + 26, x0 + pw, GROUND + 26, num(d.long)));
    g.appendChild(dim(x0 - 30, y0, x0 - 30, GROUND, num(d.height), 'left'));
    g.appendChild(dim(x0 + pw + 26, planTop, x0 + pw + 26, planTop + pd, num(d.short)));

    g.appendChild(label(x0, y0 - 18, cat === 'watch-case' ? 'ELEVATION · ROLLED' : 'ELEVATION',
      { anchor: 'start', size: 10, ls: '.22em' }));
    g.appendChild(label(x0, planTop - 14, cat === 'watch-case' ? 'PLAN · OPEN' : 'PLAN',
      { anchor: 'start', size: 10, ls: '.22em' }));

    card(g, W * 0.08, planTop + pd + 52 + CARD_H * k, k);

    return svg;
  }

  function build(box, data, cat, meta) {
    var narrow = (box.clientWidth || window.innerWidth || 1000) < 760;
    if (narrow) return buildNarrow(box, data, cat, meta);
    var W = 1000, H = 520;
    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, class: 'eld__svg',
      preserveAspectRatio: 'xMidYMid meet' });
    var g = el('g', {});
    svg.appendChild(g);

    var d = data.dims;
    if (!d) return null;
    if (cat === 'watch-case' && d.a != null) d = { long: d.a, short: d.b, height: d.height };

    var GROUND = 300, LEFT = W * 0.06, GAP = 64, ROW = W * 0.64;

    /* one scale for the whole sheet — elevation, plan and the bank card */
    var k = Math.min(
      (ROW - GAP) / (2 * d.long),   /* elevation + plan side by side */
      226 / d.height,               /* elevation height              */
      214 / d.short                 /* plan depth                    */
    );
    if (!isFinite(k) || k <= 0) k = 10;

    var pw = d.long * k, ph = d.height * k, pd = d.short * k;
    var ex = LEFT + 34, px = ex + pw + GAP;
    var ey = GROUND - ph, py = GROUND - pd;

    var radius = cat === 'watch-case' ? Math.min(ph / 2, pw / 2)
               : cat === 'tray' ? 5 : cat === 'card-sleeve' ? 4 : 3;

    g.appendChild(hair(LEFT, GROUND, px + pw + 46, GROUND, LINE));

    /* ---- elevation ---- */
    var front = el('g', { class: 'eld__body' });
    front.appendChild(el('rect', { x: ex, y: ey, width: pw, height: ph, rx: radius,
      fill: 'none', stroke: INK, 'stroke-width': 1.5, 'vector-effect': 'non-scaling-stroke' }));

    if (cat === 'watch-case') {
      front.appendChild(hair(ex + radius * 0.5, ey + ph * 0.30, ex + pw - radius * 0.5, ey + ph * 0.30, LINE, '5 4'));
      var n = data.watches || 2;
      for (var i = 0; i < n; i++) {
        front.appendChild(el('circle', { cx: ex + pw * (i + 0.5) / n, cy: ey + ph * 0.30,
          r: 2.6, fill: 'none', stroke: MUTE, 'stroke-width': 1 }));
      }
    }
    if (cat === 'chest' || cat === 'machine' || cat === 'watch-box') {
      front.appendChild(hair(ex, ey + ph * 0.26, ex + pw, ey + ph * 0.26, LINE, '5 4'));
    }
    if (cat === 'tray' && data.inside) {
      var ihh = data.inside.height * k, iww = data.inside.long * k;
      front.appendChild(el('rect', { x: ex + (pw - iww) / 2, y: GROUND - ihh, width: iww, height: ihh,
        rx: 3, fill: 'none', stroke: ACC, 'stroke-width': 1, 'stroke-dasharray': '4 3' }));
    }
    g.appendChild(front);

    /* ---- plan ---- */
    var plan = el('g', { class: 'eld__plan' });
    plan.appendChild(el('rect', { x: px, y: py, width: pw, height: pd,
      rx: cat === 'watch-case' ? 6 : radius,
      fill: 'none', stroke: MUTE, 'stroke-width': 1.2, 'vector-effect': 'non-scaling-stroke' }));
    if (cat === 'watch-case') {
      var m = data.watches || 2;
      for (var j = 1; j < m; j++) {
        plan.appendChild(hair(px + (pw / m) * j, py, px + (pw / m) * j, py + pd, LINE, '3 4'));
      }
      for (var c = 0; c < m; c++) {
        plan.appendChild(el('rect', { x: px + (pw / m) * c + pw / m * 0.14, y: py + pd * 0.22,
          width: (pw / m) * 0.72, height: pd * 0.56, rx: (pw / m) * 0.16,
          fill: 'none', stroke: LINE, 'stroke-width': 1 }));
      }
    }
    if (cat === 'tray' && data.inside) {
      plan.appendChild(el('rect', {
        x: px + (pw - data.inside.long * k) / 2, y: py + (pd - data.inside.short * k) / 2,
        width: data.inside.long * k, height: data.inside.short * k, rx: 3,
        fill: 'none', stroke: ACC, 'stroke-width': 1, 'stroke-dasharray': '4 3' }));
    }
    if (cat === 'capsule-box' && data.holds) {
      var cols = Math.max(1, Math.round(Math.sqrt(data.holds * (pw / Math.max(pd, 1)))));
      var rows = Math.ceil(data.holds / cols);
      var rr2 = Math.min(pw / cols, pd / rows) * 0.32;
      for (var q = 0; q < data.holds; q++) {
        plan.appendChild(el('circle', {
          cx: px + pw * ((q % cols) + 0.5) / cols,
          cy: py + pd * (Math.floor(q / cols) + 0.5) / rows,
          r: rr2, fill: 'none', stroke: ACC, 'stroke-width': 1 }));
      }
    }
    g.appendChild(plan);

    /* ---- dimensions ---- */
    g.appendChild(dim(ex, GROUND + 26, ex + pw, GROUND + 26, num(d.long)));
    g.appendChild(dim(ex - 30, ey, ex - 30, GROUND, num(d.height), 'left'));
    g.appendChild(dim(px + pw + 26, py, px + pw + 26, GROUND, num(d.short)));

    /* ---- annotations ---- */
    g.appendChild(label(ex, ey - 20, cat === 'watch-case' ? 'ELEVATION · ROLLED' : 'ELEVATION',
      { anchor: 'start', size: 9, ls: '.22em' }));
    g.appendChild(label(px, py - 20, cat === 'watch-case' ? 'PLAN · OPEN' : 'PLAN',
      { anchor: 'start', size: 9, ls: '.22em' }));

    /* ---- bank card, same scale, below the ground line ---- */
    card(g, LEFT + 34, GROUND + 46 + CARD_H * k, k);

    /* ---- title block ---- */
    var tb = el('g', { class: 'eld__tb' });
    var tx = W * 0.60, ty = GROUND + 78, tw = W * 0.34, th = 78;
    tb.appendChild(el('rect', { x: tx, y: ty, width: tw, height: th, fill: 'none', stroke: LINE, 'stroke-width': 1 }));
    tb.appendChild(hair(tx, ty + 26, tx + tw, ty + 26, LINE));
    tb.appendChild(hair(tx + tw * 0.68, ty + 26, tx + tw * 0.68, ty + th, LINE));
    tb.appendChild(label(tx + 12, ty + 17, 'ELEMENTO EDITION', { anchor: 'start', size: 9, ls: '.24em', fill: INK }));
    tb.appendChild(label(tx + 12, ty + 47, (meta && meta.name) || '', { anchor: 'start', size: 9, ls: '.12em' }));
    tb.appendChild(label(tx + 12, ty + 66, 'DRAWN TO SCALE · CENTIMETRES', { anchor: 'start', size: 8, ls: '.16em' }));
    tb.appendChild(label(tx + tw * 0.68 + 12, ty + 47, 'SHEET 01', { anchor: 'start', size: 9, ls: '.18em' }));
    tb.appendChild(label(tx + tw * 0.68 + 12, ty + 66, (meta && meta.ref) || '', { anchor: 'start', size: 8, ls: '.18em' }));
    g.appendChild(tb);

    return svg;
  }

  /* a sheet for pieces measured by capacity rather than by size */
  function buildCapsules(data, meta) {
    var W = 1000, H = 380;
    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, class: 'eld__svg',
      preserveAspectRatio: 'xMidYMid meet' });
    var g = el('g', {}); svg.appendChild(g);

    var n = data.holds, cols = Math.min(n, Math.ceil(Math.sqrt(n * 2.2)));
    var rows = Math.ceil(n / cols);
    var pitch = Math.min(120, (W * 0.52) / cols, 190 / rows);
    var r = pitch * 0.36;
    var ox = W * 0.07 + pitch / 2, oy = 96 + pitch / 2;

    var grid = el('g', { class: 'eld__plan' });
    for (var q = 0; q < n; q++) {
      var cx = ox + (q % cols) * pitch, cy = oy + Math.floor(q / cols) * pitch;
      grid.appendChild(el('circle', { cx: cx, cy: cy, r: r, fill: 'none', stroke: ACC, 'stroke-width': 1.2 }));
      grid.appendChild(el('circle', { cx: cx, cy: cy, r: r * 0.42, fill: 'none', stroke: LINE, 'stroke-width': 1 }));
    }
    g.appendChild(grid);
    g.appendChild(label(W * 0.07, 62, 'CAPACITY · ' + n + ' CAPSULES', { anchor: 'start', size: 9, ls: '.22em' }));

    var tb = el('g', { class: 'eld__tb' });
    var tx = W * 0.60, ty = H - 108, tw = W * 0.34, th = 78;
    tb.appendChild(el('rect', { x: tx, y: ty, width: tw, height: th, fill: 'none', stroke: LINE, 'stroke-width': 1 }));
    tb.appendChild(hair(tx, ty + 26, tx + tw, ty + 26, LINE));
    tb.appendChild(hair(tx + tw * 0.68, ty + 26, tx + tw * 0.68, ty + th, LINE));
    tb.appendChild(label(tx + 12, ty + 17, 'ELEMENTO EDITION', { anchor: 'start', size: 9, ls: '.24em', fill: INK }));
    tb.appendChild(label(tx + 12, ty + 47, (meta && meta.name) || '', { anchor: 'start', size: 9, ls: '.12em' }));
    tb.appendChild(label(tx + 12, ty + 66, 'ONE CIRCLE · ONE CAPSULE', { anchor: 'start', size: 8, ls: '.16em' }));
    tb.appendChild(label(tx + tw * 0.68 + 12, ty + 47, 'SHEET 01', { anchor: 'start', size: 9, ls: '.18em' }));
    tb.appendChild(label(tx + tw * 0.68 + 12, ty + 66, (meta && meta.ref) || '', { anchor: 'start', size: 8, ls: '.18em' }));
    g.appendChild(tb);
    return svg;
  }

  /* ---------------- plate ---------------- */

  function plate(rows) {
    var d = document.createElement('dl');
    d.className = 'eld__plate';
    rows.forEach(function (r) {
      if (!r[1]) return;
      var dt = document.createElement('dt'); dt.textContent = r[0];
      var dd = document.createElement('dd'); dd.textContent = r[1];
      d.appendChild(dt); d.appendChild(dd);
    });
    return d.children.length ? d : null;
  }

  /* ---------------- boot ---------------- */

  function init(root) {
    var nodes = (root || document).querySelectorAll('[data-eld]:not([data-eld-done])');
    [].forEach.call(nodes, function (box) {
      if (box.hasAttribute('data-eld-defer')) return;   /* waits for the sheet */
      box.setAttribute('data-eld-done', '1');
      var cat = box.getAttribute('data-cat') || '';
      var spec = text(box.querySelector('[data-eld-spec]') || document.createElement('i'));
      var mats = text(box.querySelector('[data-eld-mat]') || document.createElement('i'));
      var title = box.getAttribute('data-title') || '';
      var data = parse(spec, title);

      var stage = box.querySelector('[data-eld-stage]');
      var meta = {
        name: (title || '').replace(/^TRAVEL WATCH CASE\s*—\s*/i, '').replace(/\s*—\s*/g, ' · ').slice(0, 26),
        ref: (box.getAttribute('data-ref') || '').toUpperCase().slice(0, 18)
      };
      var svg = data.dims ? build(box, data, cat, {
        name: (title || '').replace(/^TRAVEL WATCH CASE\s*—\s*/i, '').replace(/\s*—\s*/g, ' · ').slice(0, 26),
        ref: (box.getAttribute('data-ref') || '').toUpperCase().slice(0, 18)
      }) : (data.holds ? buildCapsules(data, meta) : null);
      if (svg && stage) stage.appendChild(svg);
      else box.classList.add('is-flat');

      var rows = [];
      if (cat === 'watch-case') {
        if (data.watches) rows.push(['Holds', data.watches + (data.watches === 1 ? ' watch' : ' watches')]);
        if (data.dims) rows.push(['Rolled', num(data.dims.long) + ' × ' + num(data.dims.short) + ' × ' + num(data.dims.height)]);
      } else if (cat === 'tray') {
        if (data.outside) rows.push(['Outside', num(data.outside.long) + ' × ' + num(data.outside.short) + ' × ' + num(data.outside.height)]);
        if (data.inside) rows.push(['Inside', num(data.inside.long) + ' × ' + num(data.inside.short) + ' × ' + num(data.inside.height)]);
      } else if (data.dims) {
        rows.push(['Dimensions', num(data.dims.long) + ' × ' + num(data.dims.short) + ' × ' + num(data.dims.height)]);
      }
      if (data.holds) rows.push(['Capacity', data.holds + ' capsules']);
      if (data.volts) rows.push(['Power', data.volts]);
      var machine = box.getAttribute('data-machine');
      if (machine) rows.push(['Machine', machine]);
      if (mats) rows.push(['Materials', mats]);
      if (data.included) rows.push(['Supplied with', data.included.replace(/^(supplied with|includes|comes with)\s*/i, '')
        .replace(/^./, function (c) { return c.toUpperCase(); })]);

      var p = plate(rows);
      var slot = box.querySelector('[data-eld-plate]');
      if (p && slot) slot.appendChild(p);
      if (data.onRequest) {
        box.classList.add('is-onrequest');
        var p2 = box.querySelector('.eld__plate');
        if (p2) {
          var dt = document.createElement('dt'); dt.textContent = 'Dimensions';
          var dd = document.createElement('dd'); dd.textContent = 'On request — we measure each piece before it ships';
          p2.insertBefore(dd, p2.firstChild); p2.insertBefore(dt, p2.firstChild);
        }
      }
    });
  }

  function reveal() {
    var boxes = document.querySelectorAll('[data-eld]');
    [].forEach.call(boxes, function (b) {
      var r = b.getBoundingClientRect();
      if (r.top < (window.innerHeight || 0) * 0.88 && r.bottom > 0) b.classList.add('is-in');
    });
  }

  /* The descriptions still carry "Materials." / "Capacity." / "Includes."
     paragraphs that predate the plate. Now that the plate states those facts
     from the metafields, hide the duplicate lines in the description panel —
     but never empty it. */
  function dedupeDescription() {
    var host = document.querySelector('.v3__acc .v3__row .v3__inner');
    if (!host || host.getAttribute('data-eld-dedupe')) return;
    host.setAttribute('data-eld-dedupe', '1');
    var re = /^(materials?|includes?|included|capacity|dimensions?|finish|specifications?)\b\s*[.:\u2014-]/i;
    var kids = [].slice.call(host.children), dupes = [], kept = 0;
    kids.forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (re.test(t)) dupes.push(el); else if (t) kept++;
    });
    if (!kept || !dupes.length) return;
    dupes.forEach(function (el) { el.style.display = 'none'; });
  }

  function start() {
    init(document);
    dedupeDescription();
    setTimeout(dedupeDescription, 600);
    reveal();
    window.addEventListener('scroll', reveal, { passive: true });
    setInterval(reveal, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.ElementoDrawing = { init: init, parse: parse };
})();
